import { useHistory } from "react-router";
import {
  CartQuoteEventType,
  CartQuoteState,
  CartSelectors,
  getChildState,
  useCheckoutState,
  useCheckoutStateSelector as useSelector,
} from "@hopper-b2b/checkout";
import { useI18nContext } from "@hopper-b2b/i18n";
import { B2BLoadingPopup, ErrorModal } from "@hopper-b2b/ui";
import Error from "../../../../assets/client/error.svg";
import { PATH_FLIGHTS_SEARCH } from "../../../../utils/urlPaths";
import type { TEvent } from "../../events";
import type { PriceFreezeMachineContext } from "../../types";
import "./styles.scss";

export const CartQuoteComponent = (props) => {
  const { t } = useI18nContext();
  const history = useHistory();

  const [state, send] = useCheckoutState<TEvent, PriceFreezeMachineContext>();
  const childState = getChildState(state.value);
  const openCartQuoteModal = useSelector(CartSelectors.getOpenCartQuoteModal);

  const getMessage = (): string => {
    switch (childState) {
      case CartQuoteState.schedule:
        return t("loading");
      case CartQuoteState.polling:
        return t("loading");
      default:
        return t("loading");
    }
  };

  const open = useSelector(CartSelectors.getOpenCartQuoteErrorModal);

  const clearError = () => send(CartQuoteEventType.CLEAR_CART_QUOTE_ERROR);
  const searchAgain = () => {
    clearError();
    history.push(PATH_FLIGHTS_SEARCH);
  };

  return (
    <>
      <B2BLoadingPopup
        {...props}
        open={openCartQuoteModal}
        fullScreen
        message={getMessage()}
        popupSize={"mobile"}
      />
      )
      <ErrorModal
        open={open}
        title={t("checkoutError.genericErrorTitle")}
        subtitle={t("checkoutError.genericErrorSubtitle")}
        primaryButtonText={t("checkoutError.searchAgain")}
        primaryOnClick={searchAgain}
        image={Error}
      />
    </>
  );
};
